// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.psychologicalprices.new', {
        url:'/new',
        views: {"productView@product": {
            templateUrl: 'main/product/psychologicalprices/psychologicalprice/psychologicalprice.tpl.html',
            controller: 'PsychologicalPriceController as vm'
        }},
        resolve: {
            psychologicalPrice: function() { return {}; },
            isNewPsychologicalPrice: function() { return true; }
        }
    });

    $stateProvider.state('product.psychologicalprices.psychologicalprice', {
        url:'/{psychologicalPriceId}',
        views: {"productView@product": {
            templateUrl: 'main/product/psychologicalprices/psychologicalprice/psychologicalprice.tpl.html',
            controller: 'PsychologicalPriceController as vm'
        }},
        resolve: {
            psychologicalPrice: psychologicalPriceResolver,
            isNewPsychologicalPrice: function() { return false; }
        }
    });
}

// @ngInject
function psychologicalPriceResolver($stateParams, PsychologicalPricesApiService) {
    return PsychologicalPricesApiService.getPsychologicalPrice($stateParams.psychologicalPriceId);
}

// @ngInject
function PsychologicalPriceController($state, $rootScope, psychologicalPrice, loadSpinnerService, PsychologicalPricesApiService, isNewPsychologicalPrice, ToasterService, $translate) {
    var vm = this;

    var psychologicalPriceCopy = {};

    vm.psychologicalPrice = psychologicalPrice;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.savePsychologicalPrice = savePsychologicalPrice;

    vm.isNewPsychologicalPrice = isNewPsychologicalPrice;
    vm.isEditing = vm.isNewPsychologicalPrice;

    vm.isAllInformationValid = isAllInformationValid;
    vm.isPsychologicalPriceNameValid = isPsychologicalPriceNameValid;
    vm.addInterval = addInterval;
    vm.removeInterval = removeInterval;
    vm.clearIntervals = clearIntervals;

    activate();

    function activate() {
        prepareData();

        if (vm.isNewPsychologicalPrice) {
            vm.psychologicalPrice = {priceIntervals:[]};
            vm.newInterval = {minValue: null, maxValue: null, resultValue: null};
        } else {
            vm.newInterval = {minValue: null, maxValue: null, resultValue: null};
        }
    }

    function clearIntervals() {
        vm.psychologicalPrice.priceIntervals = [];
        vm.newInterval = {minValue: null, maxValue: null, resultValue: null};
    }

    function removeInterval(interval) {
        _.remove(vm.psychologicalPrice.priceIntervals, interval);
    }

    function addInterval(interval) {
        var hasError = false;
        var newInterval = { minValue: Number(interval.minValue), maxValue: Number(interval.maxValue), resultValue: Number(interval.resultValue)};

        //Validera max och min är numbers
        if (!_.isNumber(newInterval.minValue) || _.isNaN(newInterval.minValue)) {
            newInterval.minValue = 0;
            ToasterService.showError($translate.instant('psychologicalPrice.minValueIsWrong'), $translate.instant('common.error'));
            hasError = true;
        }

        if (!_.isNumber(newInterval.maxValue) || _.isNaN(newInterval.maxValue)) {
            newInterval.maxValue = 0;
            ToasterService.showError($translate.instant('psychologicalPrice.maxValueIsWrong'), $translate.instant('common.error'));
            hasError = true;
        }

        //Validera max > min
        if (newInterval.minValue > newInterval.maxValue) {
            newInterval.minValue = newInterval.maxValue;
            ToasterService.showError($translate.instant('psychologicalPrice.minValueLargerThanMaxValue'), $translate.instant('common.error'));
            hasError = true;
        }

        if (!hasError) {
            vm.psychologicalPrice.priceIntervals.push(newInterval);
            vm.newInterval = getNewRowDefaults(newInterval);
        }

    }

    function getNewRowDefaults(fromInterval) {
        var diff = fromInterval.maxValue - fromInterval.minValue;
        return {minValue: fromInterval.maxValue, maxValue: fromInterval.maxValue + diff, resultValue: fromInterval.resultValue + diff};
    }

    function enableEditing() {
        psychologicalPriceCopy = angular.copy(vm.psychologicalPrice);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.psychologicalPrice = psychologicalPriceCopy;
        vm.isEditing = false;
    }

    function savePsychologicalPrice() {
        if (vm.isNewPsychologicalPrice) {
            saveNewPsychologicalPrice();
        } else {
            updatePsychologicalPrice();
        }
    }

    function saveNewPsychologicalPrice() {
        loadSpinnerService.start('mainSpinner');
        PsychologicalPricesApiService.createPsychologicalPrice(vm.psychologicalPrice).then(function(response) {
            vm.psychologicalPrice = response;
            prepareData();
            vm.isNewPsychologicalPrice = false;
            vm.isEditing = false;
            ToasterService.showSuccess('"' + vm.psychologicalPrice.name + '" ' + $translate.instant("common.wasSaved"), $translate.instant("product.psychologicalprices"));
            $rootScope.$emit('PsychologicalPrice.Inserted', response);
            $state.go('product.psychologicalprices.psychologicalprice', {psychologicalPriceId: response.id});
        }, function(error) {
            ToasterService.showError(error, $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updatePsychologicalPrice() {
        loadSpinnerService.start('mainSpinner');
        PsychologicalPricesApiService.updatePsychologicalPrice(vm.psychologicalPrice).then(function(response) {
            vm.psychologicalPrice = response;
            prepareData();
            vm.isEditing = false;
            ToasterService.showSuccess('"' + vm.psychologicalPrice.name + '" ' + $translate.instant("common.wasSaved"), $translate.instant("product.psychologicalprices"));
            $rootScope.$emit('PsychologicalPrice.Changed', response);
        }, function(error) {
            ToasterService.showError(error, $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function prepareData() {
        if (vm.psychologicalPrice === undefined) {
            return;
        }
    }

    function isAllInformationValid() {
        return !vm.isNewPsychologicalPrice ||
            (isPsychologicalPriceNameValid() &&
                hasPriceIntervals()
            );
    }

    function isPsychologicalPriceNameValid() {
        return vm.psychologicalPrice && vm.psychologicalPrice.name && vm.psychologicalPrice.name.length > 0;

    }

    function hasPriceIntervals() {
        return vm.psychologicalPrice && vm.psychologicalPrice.priceIntervals && vm.psychologicalPrice.priceIntervals.length > 0;
    }
}

angular
    .module('psychologicalprices.psychologicalprice', [])
    .config(stateConfig)
    .controller('PsychologicalPriceController', PsychologicalPriceController);
